// @flow

import bemify from 'bemify-js';
import React, { Fragment } from 'react';

import { StaticImage } from '@zapier/common-components';

import SimplePromo from 'app/login/components/SimplePromo';
import { GLOBAL_APP_COUNT } from 'app/common/contants';
import { Heading2 } from 'app/common/components/Heading';
import { TeamContainerFeatureItems } from 'app/login/components/FeatureItems';
import 'app/login/components/TeamMemberPromo.scss';

import type { SimplePromoProps } from 'app/login/components/SimplePromo';

const bem = bemify('team-member-invite');

const title = `Zapier's free platform connects your app to ${GLOBAL_APP_COUNT}+ of the web's top tools.`;
// When an app has no logo the BE defaults to this logo value taken from
// PLACEHOLDER_LOGO in snapbook/constants.py.
const PLACEHOLDER_PATH = '/frontend/placeholder';

const isAppImagePlaceholder = imgSrc =>
  imgSrc && imgSrc.includes(PLACEHOLDER_PATH);

const header = appImage => (
  <header className={bem('__header')}>
    <div className={bem('__header-image')}>
      <StaticImage className={bem('__logo')} src="/images/logomark250.png" />
      {!isAppImagePlaceholder(appImage) && (
        <Fragment>
          <svg className={bem('__divider')} viewBox="0 0 38 7">
            <circle cx="3.25292" cy="3.25438" fill="#969EA2" r="3.25292" />
            <circle cx="18.9753" cy="3.25292" fill="#969EA2" r="3.25292" />
            <circle cx="34.6977" cy="3.25292" fill="#969EA2" r="3.25292" />
          </svg>
          <StaticImage className={bem('__icon')} src={appImage} />
        </Fragment>
      )}
    </div>
    <Heading2 className={bem('__title')}>{title}</Heading2>
  </header>
);

const TeamMemberPromo = (props: {
  ...$Exact<SimplePromoProps>,
  appImage: string,
}) => (
  <SimplePromo
    {...props}
    className={bem('__simple-promo')}
    condensedIcon="info"
    header={header(props.appImage)}
    title={title}
  >
    <TeamContainerFeatureItems />
  </SimplePromo>
);

export default TeamMemberPromo;
